import { FormInput, InputProps, copyTextToClipboard } from '@systemeio/ui'
import { MEDIA_AT_SIGN } from 'modules/stores/store/content/profile/utils/get-social-link-label'
import React, { FC } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { LinkIcon } from '@systemeio/ui/icons'

interface FormInputMediaProps extends Omit<InputProps, 'value' | 'onChange' | 'addonAfter'> {
  value?: string
  onChange: (value: string) => void
  withCopyButton?: boolean
}

const FormInputMedia: FC<FormInputMediaProps> = ({
  onChange,
  value = '',
  addonBefore,
  withCopyButton,
  ...rest
}) => {
  const { t } = useLocoTranslation()

  const sanitizedValue = value.replace(MEDIA_AT_SIGN, '')

  const onChangeMedia = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
    if (!value) return onChange('')
    if (value === MEDIA_AT_SIGN) return onChange('')
    onChange(value.replace(MEDIA_AT_SIGN, ''))
  }

  return (
    <FormInput
      type={'url'}
      addonBefore={addonBefore || MEDIA_AT_SIGN}
      value={sanitizedValue}
      onChange={onChangeMedia}
      addonAfterClassName={'p-0 sm:p-0 lg:p-0 border-0'}
      addonAfter={
        withCopyButton && (
          <button
            type={'button'}
            onClick={async e => {
              e.preventDefault()
              await copyTextToClipboard(value, t('global.copy_clipboard'))
            }}
            className={`bg-brand-primary hover:bg-brand-primary-hover ring-brand-primary flex h-full items-center justify-center rounded-r-lg px-2 py-2.5 ring-offset-1 focus:outline-hidden focus-visible:ring-2 sm:px-4`}
          >
            <LinkIcon
              className={`fill-background-secondary h-[15px] w-[15px] sm:h-[20px] sm:w-[20px]`}
            />
          </button>
        )
      }
      {...rest}
    />
  )
}

export default FormInputMedia
